<template>
  <div class="item">
    <InfoItem
      v-for="(item, index) in items"
      :key="items[index].key"
      :itemKey="items[index].key"
      :itemValue="convertToK(items[index].value) + ''"
      :color="items[index].color"
      :loading="loadingStatus"
      @item-clicked="handleItemClicked"
    />
  </div>
</template>
<script>
import InfoItem from './info-item.vue';
import { convertToK } from '@/utils/helper-function';

export default {
  components: { InfoItem },
  data() {
    return {
      type: 'ByCap',
    };
  },
  props: {
    loadingStatus: { type: Boolean, default: false },
    containersData: { type: Array, default: () => [] },
  },
  methods: {
    convertToK,
    handleItemClicked(item) {
      this.$emit('info-selected', item);
    },
  },
  computed: {
    items() {
      return this.containersData.map((app) => {
        return { ...app, key: app.key };
      });
    },
  },
};
</script>
<style scoped>
.item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
